// extracted by mini-css-extract-plugin
export default {"Toggle":"CustomToggle_Toggle__81GcR"};